import * as React from "react";
import { MapPin, Phone, Smartphone, Map } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: 1,
  name: "Main Financial District",
  address: "123 Wall Street, Suite 500, New York, NY 10005",
  phone: "(212) 555-0198",
  whatsapp: "(212) 555-0199",
  mapUrl: "https://maps.google.com/?q=123+Wall+Street+New+York",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/premier_loans_manhattan_office.png"
}, {
  id: 2,
  name: "West Coast Branch",
  address: "456 Financial Way, Los Angeles, CA 90012",
  phone: "(310) 555-0142",
  whatsapp: "(310) 555-0143",
  mapUrl: "https://maps.google.com/?q=Financial+Way+Los+Angeles",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/premier_loans_la_office.png"
}, {
  id: 3,
  name: "Chicago Corporate",
  address: "789 Mortgage Plaza, Chicago, IL 60601",
  phone: "(312) 555-0167",
  whatsapp: "(312) 555-0168",
  mapUrl: "https://maps.google.com/?q=Mortgage+Plaza+Chicago",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/premier_loans_chicago_office.png"
}];
export default function VisitOurOffice() {
  return <section data-section-id="224972" id="visit-our-office" className="w-full bg-background text-foreground py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="font-default text-secondary text-sm font-bold uppercase tracking-widest mb-2 block">
            Our Presence
          </span>
          <h2 className="font-serif text-primary text-4xl md:text-5xl font-bold tracking-tight">
            Visit Our Office
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {locations.map((loc, i) => <Card key={loc.id} data-index={i} className="rounded-md shadow-xl border-border overflow-hidden flex flex-col h-full bg-card transition-transform duration-300 hover:scale-[1.02]">
              <div className="h-48 w-full relative bg-muted">
                <img src={loc.image} alt={`Map location for ${loc.name}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
              </div>
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-2xl font-serif text-primary">
                  {loc.name}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-6 pb-6 flex-grow flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                  <span className="text-muted-foreground font-default text-sm leading-relaxed">
                    {loc.address}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-secondary shrink-0" />
                  <span className="text-muted-foreground font-default text-sm">
                    {loc.phone}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Smartphone className="w-5 h-5 text-secondary shrink-0" />
                  <span className="text-muted-foreground font-default text-sm">
                    {loc.whatsapp}
                  </span>
                </div>
              </CardContent>
              <CardFooter className="px-6 pb-6 pt-0 mt-auto">
                <Button asChild variant="default" className="w-full rounded-md font-default uppercase tracking-widest bg-gradient-to-r from-secondary to-amber-600 hover:opacity-90 transition-opacity">
                  <Link to={loc.mapUrl} newTab>
                    <Map className="w-4 h-4 mr-2" />
                    Get Directions
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}